export default {"src":"/_next/static/media/platinumPlanBackground.764ff78c.svg","height":94,"width":328,"blurWidth":0,"blurHeight":0};